import { AppHeader } from "../../components/AppHeader";
import { AppFooter } from "../../components/AppFooter";
import { usePageTitle } from "../../hooks/usePageTitle";
import { useIsMobile } from "../../hooks/useIsMobile";

export function PrivacyPage() {
  usePageTitle("개인정보 처리방침");
  const m = useIsMobile();

  return (
    <div style={st.page}>
      <AppHeader />
      <div style={{ ...st.container, padding: m ? "24px 16px 60px" : "40px 32px 80px" }}>
        <div style={st.header}>
          <h1 style={st.mainTitle}>{"개인정보 처리방침"}</h1>
          <p style={st.subtitle}>{"Privacy Policy"}</p>
          <p style={st.updated}>{"최종 업데이트: 2026년 3월 1일"}</p>
        </div>

        <Section title="제1조 (개인정보 처리방침의 의의)">
          <p>{"땅신뢰(LandTrust, 이하 '서비스')는 공인중개사 전용 토지·임야 매물 정보 공유 플랫폼입니다. 서비스 운영자 genomic.cc(이하 '운영자')는 「개인정보 보호법」 및 관련 법령에 따라 이용자의 개인정보를 보호하고, 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 다음과 같이 개인정보 처리방침을 수립·공개합니다."}</p>
        </Section>

        <Section title="제2조 (수집하는 개인정보 항목)">
          <p>{"운영자는 서비스 제공을 위해 다음의 개인정보를 수집합니다."}</p>
          <Table
            headers={["구분", "수집 항목", "수집 방법"]}
            rows={[
              ["회원가입 시", "이름, 휴대폰 번호, 비밀번호(암호화), 공인중개사 자격증번호, 사무소명, 활동 지역(시도·시군구)", "이용자 직접 입력"],
              ["서비스 이용 시", "매물 등록 정보(소재지, 면적, 가격, 사진 등), NDA 동의 기록(이름, 동의 일시)", "이용자 직접 입력"],
              ["문의 접수 시", "문의자 이름, 문의자 연락처, 문의 내용", "이용자 직접 입력"],
              ["자동 수집", "접속 IP, 접속 일시, 서비스 이용 기록", "자동 생성"],
            ]}
          />
          <p style={st.note}>{"※ 비밀번호는 암호화(bcrypt)하여 저장되며, 운영자도 원문을 확인할 수 없습니다."}</p>
        </Section>

        <Section title="제3조 (개인정보 수집 및 이용 목적)">
          <p>{"수집한 개인정보는 다음의 목적으로만 이용됩니다."}</p>
          <ul style={st.list}>
            <li>{"회원 가입 및 본인 확인 (공인중개사 자격 확인)"}</li>
            <li>{"서비스 제공: 블라인드 매물 등록, 매물 조회, NDA 동의 관리"}</li>
            <li>{"매물 문의 처리 및 중개사 간 정보 전달"}</li>
            <li>{"신뢰도 점수 관리 및 서비스 품질 향상"}</li>
            <li>{"법령 준수 및 분쟁 해결"}</li>
          </ul>
        </Section>

        <Section title="제4조 (개인정보 보유 및 이용 기간)">
          <Table
            headers={["항목", "보유 기간", "근거"]}
            rows={[
              ["회원정보 (이름, 연락처, 자격증번호 등)", "회원 탈퇴 시까지", "정보주체 동의"],
              ["매물 정보", "매물 삭제 또는 회원 탈퇴 시까지", "정보주체 동의"],
              ["NDA 동의 기록", "회원 탈퇴 후 1년", "분쟁 해결 목적"],
              ["문의 기록", "접수 후 1년", "서비스 운영 목적"],
              ["접속 로그", "3개월", "통신비밀보호법"],
            ]}
          />
        </Section>

        <Section title="제5조 (개인정보의 제3자 제공)">
          <p>{"운영자는 원칙적으로 이용자의 개인정보를 제3자에게 제공하지 않습니다. 다만, 다음의 경우는 예외로 합니다."}</p>
          <ul style={st.list}>
            <li>{"이용자가 사전에 동의한 경우"}</li>
            <li>{"법령의 규정에 의한 경우 (수사기관의 요청 등)"}</li>
          </ul>
          <p style={st.note}>{"※ NDA 동의 후 열람하는 매물 정보(정확한 주소, 소유자 연락처 등)는 해당 매물을 등록한 중개사가 제공한 정보이며, 비밀유지 의무가 부여됩니다."}</p>
        </Section>

        <Section title="제6조 (위치정보 처리)">
          <p>{"서비스는 매물의 위치 표시를 위해 좌표 정보를 처리합니다."}</p>
          <ul style={st.list}>
            <li>{"블라인드 좌표: 실제 위치에서 ±200m~1km 오프셋 적용하여 공개 (NDA 미동의 시)"}</li>
            <li>{"정확 좌표: NDA 동의한 이용자에게만 공개 (서브컬렉션 분리 저장)"}</li>
            <li>{"이용자 단말기의 위치 정보는 수집하지 않습니다."}</li>
          </ul>
        </Section>

        <Section title="제7조 (개인정보 처리의 위탁)">
          <Table
            headers={["수탁업체", "위탁 업무", "보유 기간"]}
            rows={[
              ["Google Firebase (Firestore)", "회원정보 및 매물 데이터 저장", "회원 탈퇴 시까지"],
              ["Cloudflare Workers", "API 서버 운영", "처리 완료 즉시 삭제"],
            ]}
          />
        </Section>

        <Section title="제8조 (정보주체의 권리·의무 및 행사 방법)">
          <p>{"이용자는 언제든지 다음의 권리를 행사할 수 있습니다."}</p>
          <ul style={st.list}>
            <li>{"개인정보 열람 요구"}</li>
            <li>{"오류 정정 요구"}</li>
            <li>{"삭제 요구 (탈퇴를 통한 삭제)"}</li>
            <li>{"처리 정지 요구"}</li>
          </ul>
          <p>{"권리 행사는 운영자에게 서면, 전자우편으로 요청할 수 있으며, 운영자는 10일 이내에 조치 결과를 알려드립니다."}</p>
        </Section>

        <Section title="제9조 (개인정보 보호를 위한 안전성 확보 조치)">
          <ul style={st.list}>
            <li>{"관리적 조치: 내부 관리계획 수립, 직원 대상 교육"}</li>
            <li>{"기술적 조치: 개인정보처리시스템 접근권한 관리, 비밀번호 암호화(bcrypt), HTTPS 통신"}</li>
            <li>{"물리적 조치: 클라우드 기반 데이터센터(Google, Cloudflare) 보안 준수"}</li>
          </ul>
        </Section>

        <Section title="제10조 (쿠키 사용)">
          <p>{"서비스는 쿠키를 사용하지 않습니다. 인증 정보(JWT 토큰)는 브라우저 localStorage에만 저장됩니다."}</p>
        </Section>

        <Section title="제11조 (개인정보 보호책임자)">
          <Table
            headers={["구분", "내용"]}
            rows={[
              ["성명", "김창훈"],
              ["소속/직위", "genomic.cc 대표"],
              ["연락처", "admin@genomic.cc"],
            ]}
          />
          <p>{"개인정보 관련 문의, 불만 처리, 피해 구제 등에 관한 사항을 위 담당자에게 문의하실 수 있습니다."}</p>
        </Section>

        <Section title="제12조 (개인정보 처리방침 변경)">
          <p>{"본 처리방침은 법령·정책 또는 서비스 변경으로 내용 추가·삭제 및 수정이 있을 경우, 변경 사항의 시행일 7일 전부터 서비스 내 공지사항을 통하여 고지할 것입니다."}</p>
        </Section>

        <Section title="부칙">
          <p>{"본 방침은 2026년 3월 1일부터 시행됩니다."}</p>
        </Section>
      </div>
      <AppFooter />
    </div>
  );
}

// ── 서브 컴포넌트 ──────────────────────────────────────
function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div style={st.section}>
      <h2 style={st.sectionTitle}>{title}</h2>
      <div style={st.sectionBody}>{children}</div>
    </div>
  );
}

function Table({ headers, rows }: { headers: string[]; rows: string[][] }) {
  return (
    <div style={{ overflowX: "auto", margin: "12px 0" }}>
      <table style={st.table}>
        <thead>
          <tr>
            {headers.map((h) => <th key={h} style={st.th}>{h}</th>)}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={i}>
              {row.map((cell, j) => <td key={j} style={st.td}>{cell}</td>)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

// ── 스타일 ──────────────────────────────────────
const gold = "#D4A853";
const st: Record<string, React.CSSProperties> = {
  page: { minHeight: "100vh", display: "flex", flexDirection: "column", background: "var(--bg-primary)" },
  container: { maxWidth: 1200, margin: "0 auto", flex: 1 },
  header: { textAlign: "center", marginBottom: 40, paddingBottom: 28, borderBottom: "1px solid var(--border-light)" },
  mainTitle: { fontSize: 30, fontWeight: 900, color: "var(--text-primary)", margin: "0 0 8px" },
  subtitle: { fontSize: 15, color: "var(--text-muted)", margin: "0 0 8px" },
  updated: { fontSize: 13, color: "var(--text-muted)", margin: 0 },
  section: { marginBottom: 32 },
  sectionTitle: {
    fontSize: 16, fontWeight: 700, color: gold,
    padding: "10px 16px", margin: "0 0 14px",
    background: "rgba(212,168,83,0.08)",
    borderLeft: `3px solid ${gold}`,
    borderRadius: "0 8px 8px 0",
  },
  sectionBody: { paddingLeft: 4, lineHeight: "1.8", color: "var(--text-secondary)", fontSize: 14 },
  list: { margin: "8px 0", paddingLeft: 20, display: "flex", flexDirection: "column", gap: 6 },
  note: { fontSize: 12, color: "var(--text-muted)", margin: "8px 0 0", fontStyle: "italic" },
  table: { width: "100%", borderCollapse: "collapse", fontSize: 13, minWidth: 400 },
  th: {
    padding: "9px 12px", background: "var(--bg-card)",
    color: "var(--text-secondary)", fontWeight: 600,
    border: "1px solid var(--border-light)", textAlign: "left",
  },
  td: {
    padding: "9px 12px", color: "var(--text-secondary)",
    border: "1px solid var(--border-light)",
    verticalAlign: "top", lineHeight: "1.6",
  },
};
